module.exports = __webpack_public_path__ + "static/media/1 13 vært.2bc7354f.mp3";